import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { onGiveTheThumbsUp } from "@/pages/Gallery/hooks";
import { GalleryItemType, galleryStore, ImgAndPromptItemType } from "@/stores/gallery";
import styles from "./index.module.scss";
import config from "@/config";

interface GiveTheThumbsUpProps {
  image_id: number;
  style?: React.CSSProperties;
  likes?: number;
  is_like?: boolean;
  onLike?: (image_id: number) => void;
  onCancelLike?: (image_id: number) => void;
  onError?: (e: any) => void;
  photos?: GalleryItemType[];
  imgAndPromptList?: ImgAndPromptItemType[];
}
const GiveTheThumbsUp: FC<GiveTheThumbsUpProps> = ({
  image_id,
  style,
  likes,
  is_like,
  onLike,
  onCancelLike,
  onError,
  photos = galleryStore.galleryData.list,
  imgAndPromptList = galleryStore.imgAndPromptList,
}) => {
  return (
    <div
      style={style}
      className={styles.giveTheThumbsUpWrapper}
      onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await onGiveTheThumbsUp(
          photos,
          imgAndPromptList,
          image_id,
          !is_like,
          onLike,
          onCancelLike,
          onError,
        );
      }}
    >
      <img
        src={
          !is_like
            ? `${config.buildCdnBaseUrl}assets/creator/giveTheThumbsUp.png`
            : `${config.buildCdnBaseUrl}assets/creator/activeGiveTheThumbsUp.png`
        }
        alt=""
        style={{ marginRight: !likes ? 0 : "" }}
      />
      <span style={{ marginLeft: 10 }}>{likes ? likes : 0}</span>
    </div>
  );
};
export default observer(GiveTheThumbsUp);
